import { Button } from '@mui/material';
import { FC } from 'react';
import { useFormContext } from 'react-hook-form';
import { isEmptyObject } from '@vy/utils';
import { useFetchQuickBooksSettings } from '../hooks/useFetchQuickBooksSettings';
import { useModifyConfiguration } from '../hooks/useModifyConfiguration';
import type { QuickBooksConfigurationFormValues } from '../QuickBooksConfigurationFormSchema';
import { getQuickBooksIntegrationSettings } from './utils';
import { useIntegrationContextProvider } from '../../../../hooks/use-integration-context-provider';

export const QuickBooksConfigurationFooter: FC = () => {
  const { integrationId } = useFetchQuickBooksSettings();
  const updateQuickBooksConfiguration = useModifyConfiguration();
  const { clearSelectedIntegration } = useIntegrationContextProvider();

  const {
    handleSubmit,
    formState: { dirtyFields },
    reset,
  } = useFormContext<QuickBooksConfigurationFormValues>();

  const { syncCustomer, ...formDirtyValues } = dirtyFields;

  const getUpdateQuickBooksConfigurationPromise = async (formValues: QuickBooksConfigurationFormValues) => {
    if (isEmptyObject(formDirtyValues)) {
      return undefined;
    }

    const updatedIntegrationSettings = getQuickBooksIntegrationSettings(formValues);

    return updateQuickBooksConfiguration(integrationId, updatedIntegrationSettings);
  };

  const submitHandler = handleSubmit(async (formValues) => {
    await getUpdateQuickBooksConfigurationPromise(formValues);

    reset(formValues);

    clearSelectedIntegration();
  });

  return (
    <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
      <Button variant="contained" onClick={submitHandler} disabled={isEmptyObject(formDirtyValues)}>
        Save Configuration
      </Button>
    </div>
  );
};
